// /**
//  *  @class
//  *  @function ProductRecommendations
//  */
// class ProductRecommendations extends HTMLElement {
// 	constructor() {
// 		super();

// 		this.parent = this.closest('.product-recommendations--parent');

// 	}
// 	fetchProducts() {
// 		fetch(this.dataset.url)
// 			.then(response => response.text())
// 			.then(text => {
// 				const html = document.createElement('div');
// 				html.innerHTML = text;
// 				const recommendations = html.querySelector('product-recommendations');

// 				if (recommendations && recommendations.innerHTML.trim().length) {
// 					this.innerHTML = recommendations.innerHTML;

// 					if ( this.parent ) {
// 						this.parent.classList.add('product-recommendations--full');

// 						if ( OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
// 							this.parent.classList.add('active');
// 						}
// 					}

// 				}

// 				this.classList.add('product-recommendations--loaded');

// 			})
// 			.catch(e => {
// 				console.error(e);
// 			});
// 	}
// 	connectedCallback() {
// 		this.fetchProducts();
// 	}
// }

// customElements.define('product-recommendations', ProductRecommendations);

/**
 * @class
 * @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');
	}

	fetchProducts() {
		const url = this.dataset.url;

		if (!url) {
			this.classList.add('product-recommendations--loaded');
			return;
		}

		fetch(url)
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error: ${response.status}`);
				}

				return response.text();
			})
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;

				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if (this.parent) {
						this.parent.classList.add('product-recommendations--full');

						if (
							typeof OverlayManager !== 'undefined' &&
							OverlayManager.isOpen(document.getElementById('Cart-Drawer'))
						) {
							this.parent.classList.add('active');
						}
					}
				}

				this.classList.add('product-recommendations--loaded');
			})
			.catch(error => {
				console.error('Product recommendations error:', error);
				this.classList.add('product-recommendations--loaded');
			});
	}

	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
